// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmPayoutDialog-BankIconImage_cls1__-x+CC","cls2":"ConfirmPayoutDialog-BankIconImage_cls2__8DkN+ ConfirmPayoutDialog-BankIconImage_cls1__-x+CC"};